/*eslint-disable*/
import api from '../'

class BonusesApi {
    static list(params, cancelToken = null) {
        return api.axios.get('/bonus-games-panel', {params, cancelToken})
            .then(response => response.data);
    }

    static create (params) {
        return api.axios.post('/bonus-games-panel', params)
            .then(response => response.data);
    }

    static delete (id) {
        return api.axios.delete('/bonus-games-panel/' + id)
            .then(response => response.data);
    }

    static update (params) {
        return api.axios.put('/bonus-games-panel/' + params.id, params.bonus)
            .then(response => response.data);
    }

    static show (id) {
        return api.axios.get('/bonus-games-panel/' + id)
            .then(response => response.data);
    }
}

export default BonusesApi;